import { X, History, BrainCircuit, LayoutGrid, Cast, Settings, LogOut } from "lucide-react";

// Mobile action sheet opened from the bottom-nav "Menu" / "Plus" pill.
export function MobileMenuSheet({ open, onClose, onHistory, onMemory, onSkills, onCast, onSettings, onLogout }) {
  if (!open) return null;
  const go = (fn) => { onClose?.(); fn?.(); };
  const items = [
    { id: "history", label: "Historique", icon: History, onClick: onHistory },
    { id: "memory", label: "Mémoire", icon: BrainCircuit, onClick: onMemory },
    { id: "skills", label: "Modules", icon: LayoutGrid, onClick: onSkills },
    { id: "cast", label: "Diffuser sur écran", icon: Cast, onClick: onCast },
    { id: "settings", label: "Paramètres", icon: Settings, onClick: onSettings },
  ];
  return (
    <div data-testid="mobile-menu-sheet" className="md:hidden fixed inset-0 z-[70] flex items-end" onClick={onClose}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className="relative w-full glass-card rounded-t-3xl p-4 pb-8 animate-rise" onClick={(e) => e.stopPropagation()}>
        <div className="mx-auto mb-4 h-1 w-10 rounded-full bg-slate-600" />
        <div className="mb-2 flex items-center justify-between px-1">
          <span className="font-jb text-[11px] tracking-[0.3em] uppercase text-cyan-300">Menu</span>
          <button data-testid="mobile-menu-close" onClick={onClose} aria-label="Fermer" className="h-8 w-8 flex items-center justify-center rounded-full text-slate-400">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex flex-col gap-1.5">
          {items.map(({ id, label, icon: Icon, onClick }) => (
            <button key={id} data-testid={`menu-${id}`} onClick={() => go(onClick)} className="sara-navitem">
              <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
              <span>{label}</span>
            </button>
          ))}
          <button data-testid="menu-logout" onClick={() => go(onLogout)} className="sara-navitem text-rose-300 hover:text-rose-200">
            <LogOut className="h-[18px] w-[18px]" strokeWidth={1.75} />
            <span>Déconnexion</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileMenuSheet;
